import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import DOMPurify from 'dompurify'
import FormInput from '../../components/form-input'
import Button from '../../components/button'
import { useLogin } from '../../redux/user/hook'
import { formValidation } from '../../utils/functions'
import AuthLayout from '../../components/layouts/auth'
import { useSelector } from 'react-redux'
import { setAlert } from '../../redux/components/components-slice'
import { store } from '../../redux'
import GoogleImage from '../../assets/img/google-play-badge.png'
import AppleImage from '../../assets/svg/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
import illustrateSVG from '../../assets/svg/illustrate-user.svg'
import Logo from '../../components/logo'
import PasswordInput from '../../components/PasswordInput'

const SignInPage = () => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })
  const [loginSection, setloginSection] = useState('payroll')

  const { section } = useSelector((state) => state.sectionSlice)

  useEffect(() => {
    if (section) {
      if (section.name == 'core hr') {
        setloginSection('core hr')
      } else if (section.name == 'spend management') {
        setloginSection('spend management')
      }
    }
  }, [section])

  const { mutate: signIn, isLoading: loading } = useLogin()
  const { webToken } = useSelector((state) => state.userSlice)

  useEffect(() => {}, [])

  const submitForm = async (data) => {
    if (loginSection) {
      const email = DOMPurify.sanitize(data?.email)
      const password = DOMPurify.sanitize(data?.password)
      const source = 'web'
      const web_token = webToken ? webToken : 'no_token'

      const requestData = {
        email,
        password,
        section: loginSection,
        source,
        web_token,
      }
      signIn(requestData)
    } else {
      store.dispatch(setAlert(true, 'info', 'Select a module to log in'))
    }
  }

  return (
    <AuthLayout>
      <>
        <form
          className='form flex  h-full w-full flex-col gap-2'
          onSubmit={handleSubmit(submitForm)}
        >
          <p className={'text-[25px] font-semibold'}>Sign in</p>
          <div className='flex flex-col'>
            <div className='flex flex-col '>
              <p className='text-base font-semibold'>Email</p>
              <FormInput
                label=''
                placeholder={'Email'}
                name='email'
                type='text'
                inputRef={register(formValidation('email', true))}
                readOnly={loading}
                error={errors.email}
                errorMessage={errors.email && errors.email.message}
              />
            </div>

            <div className='flex flex-col '>
              <p className='text-base font-semibold'>Password</p>
              <PasswordInput
                placeholder='Password'
                name='password'
                inputRef={register(formValidation('password', true))}
                readOnly={loading}
                error={errors.password}
                errorMessage={errors.password && errors.password.message}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <div className='cursor-pointer hover:underline text-base text-hr-primary-1 font-extrabold'>
                <Link to='/forgot'>Forgot Password?</Link>
              </div>
              <FormInput
                label='Remember me'
                name='remember'
                type='checkbox'
                inputRef={register(formValidation('checkbox'))}
                className={'!text-[13px]'}
                readOnly={loading}
                error={errors.remember}
                errorMessage={errors.remember && errors.remember.message}
              />
            </div>
          </div>
          <Button
            text='Sign in'
            type='submit'
            theme='third'
            loading={loading}
            disabled={loading}
          />
          <div className='flex flex-col gap-1 mt-2'>
            <p>
              New to CentelHR?{' '}
              <span>
                <Link to='/register'>
                  <span className='text-base underline font-extrabold text-hr-primary-1'>
                    Get Started
                  </span>
                </Link>
              </span>
            </p>
            <p>
              Need help?{' '}
              <span>
                <a
                  href='https://centelhr.com/help-center'
                  target='_blank'
                  rel='noreferrrer'
                >
                  <span className='text-base underline font-extrabold text-hr-primary-1'>
                    Visit our help center
                  </span>
                </a>
              </span>
            </p>
          </div>
        </form>
      </>
    </AuthLayout>
  )
}

export default SignInPage
